var routeMatch = function (urlPath, maskedPath) {
    try {
        var pathChunks_1 = urlPath.split('/').filter(Boolean);
        var maskedChunks = maskedPath.split('/').filter(Boolean);
        // handle for home page path "/"
        if (maskedChunks.length === 0 && pathChunks_1.length === 0) {
            return true;
        }
        // early return for incompatible path size
        if (pathChunks_1.length !== maskedChunks.length)
            return false;
        return maskedChunks.every(function (chunk, i) { return chunk.startsWith(':') || pathChunks_1[i] === chunk; });
    }
    catch (_) {
        return false;
    }
};
export default routeMatch;
//# sourceMappingURL=route-match.js.map